/**
 * Custom hook for company data fetching and management
 */
import { useState, useEffect, useCallback } from "react";
import { toast } from "sonner";
import { apiClient, getErrorMessage } from "../../../utils/api";

export const useCompanyData = (companyId, token, canAssignAgents, navigate) => {
  const [company, setCompany] = useState(null);
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [agents, setAgents] = useState([]);

  const fetchData = useCallback(async () => {
    try {
      const [companyRes, activitiesRes] = await Promise.all([
        apiClient.get(`/companies/${companyId}`),
        apiClient.get(`/companies/${companyId}/activities`)
      ]);
      setCompany(companyRes.data);
      setActivities(activitiesRes.data);
    } catch (error) {
      console.error("Failed to fetch data:", error);
      toast.error(getErrorMessage(error));
      navigate("/");
    } finally {
      setLoading(false);
    }
  }, [companyId, navigate]);

  const fetchAgents = useCallback(async () => {
    if (!canAssignAgents) return;
    try {
      const response = await apiClient.get('/users/agents');
      setAgents(response.data);
    } catch (error) {
      console.error("Failed to fetch agents:", error);
    }
  }, [canAssignAgents]);

  useEffect(() => {
    if (token && companyId) {
      fetchData();
      fetchAgents();
    }
  }, [token, companyId, fetchData, fetchAgents]);

  return {
    company,
    activities,
    loading,
    agents,
    refetch: fetchData
  };
};
